import React, { PropTypes } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';


const LoadingFSView = ({showLoadingFS, loadingFSText1, loadingFSText2}) => (
	<div className={classNames('', {'hidden': !showLoadingFS})}>
		<div id="loadingFS">
			<h1>{loadingFSText1}</h1>
			<svg className="cyclops-icon cyclops-spin" aria-hidden="true"><use xlinkHref='#icon-settings' /></svg>
			<h5>{loadingFSText2}</h5>
		</div>
	</div>
);

LoadingFSView.PropTypes = {
	showLoadingFS: PropTypes.bool,
	loadingFSText1:PropTypes.string,
	loadingFSText2:PropTypes.string
};

// Redux purt follows:

const mapStateToProps = ( state ) => ({
	showLoadingFS: state.toggleFSLOadingRed.showLoadingFS,
	loadingFSText1: state.toggleFSLOadingRed.loadingFSText1,
	loadingFSText2: state.toggleFSLOadingRed.loadingFSText2
});

const LoadingFS = connect(mapStateToProps)(LoadingFSView);

export default LoadingFS;


/** WEBPACK FOOTER **
 ** ./src/components/LoadingFS.js
 **/